import { useTheme } from '@mui/material'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useCallback } from 'react'

import { ContactInformation as ContactInformationForm } from '@components/profile_form/form'
import { useBookingContext } from '@providers/booking'
import { i18WithDefault as t } from '@shared/locale'
import { Spacer3 } from 'components-ui'
import { TDetailsPoliciesForm } from './details_policies.d'

type TContactInformationProps = {
  formik: TDetailsPoliciesForm
  consentToSMS: boolean
  handleConsentToggle: () => void
}

export const ContactInformation = ({ formik, consentToSMS, handleConsentToggle }: TContactInformationProps) => {
  const bookingCtx = useBookingContext()
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  const onChange = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (ev: React.ChangeEvent<any>) => {
      const { name, id, dataset, value } = ev.target
      const nspace = name === 'state' ? 'mailingAddress' : dataset?.nspace
      bookingCtx.dispatch({
        type: 'SET_CONTACT_FIELD',
        payload: {
          value: {
            nspace,
            fieldName: name || id,
            value,
          },
        },
      })

      formik.handleChange(ev)
    },
    [bookingCtx, formik]
  )

  const onStateSelect = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_ev: React.ChangeEvent<any>, value: any) => {
      bookingCtx.dispatch({
        type: 'SET_CONTACT_FIELD',
        payload: {
          value: {
            nspace: 'mailingAddress',
            fieldName: 'state',
            value,
          },
        },
      })
      formik.setFieldValue('state', value.code)
    },
    [bookingCtx, formik]
  )

  return (
    <Paper elevation={1} sx={{ p: 2, pb: 3, borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
      <Typography variant="h5">{t('detailsPolicies.contactInformation')}</Typography>
      <Spacer3 />

      <ContactInformationForm
        formik={formik}
        onChange={onChange}
        onChangeSelect={onStateSelect}
        size="small"
        showConsentPrompt={true}
        consentToSMS={consentToSMS}
        handleConsentToggle={handleConsentToggle}
      />
    </Paper>
  )
}
